<template>
  <div>
    <search-bar @search="onSearch" name="cu_name" placeholder="输入客户进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.cu_name}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.cd_biz_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <!-- <p>{{item.cd_biz_name}}</p> -->
          <p>
            <span v-format="'#,##0.00'">{{item.cd_end}}</span>
            &nbsp;{{item.cd_currency}}
          </p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}单</label>
      <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/ledger/cust_detail/list",
      params: {
        mode: "DETAIL",
        calculateFields: JSON.stringify([
          {"field":"cd_currency","operation":"max"},
          {"field":"cd_rec","operation":"sum"},
          {"field":"cd_pre","operation":"sum"},
          {"field":"cd_end"}
        ])
      },
      filters: [
        {
          type: "period",
          name: "cd_yearmonth"
        },
        {
          type: "currency",
          name: "cd_currency"
        }
      ],
    };
  },
  mounted() {
    this.doSearch()
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "MoneyReceiptReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
    getTotal() {
      var me = this,
        items = me.items,
        total = 0
      items.forEach((item, index) => {
        if(index > 0 && item.cd_custid == items[index - 1].cd_custid) {
          total += item.cd_rec;
          total += item.cd_pre
        } else {
          total += item.cd_end
        }
      });
      return total;
    },
  },
};
</script>